import React, { FunctionComponent, useState } from 'react';
import { IntlProvider } from 'react-intl';
import LocalizedStrings from '../lang/LocalizedStrings';

const defaultLocale = "fi-FI";

export const IntlContext = React.createContext({
    locale: defaultLocale,
    messages: LocalizedStrings[defaultLocale],
    switchToEnglish: () => {},
    switchToSwedish: () => {},
    switchToFinnish: () => {},
});

interface IWrapperProps extends React.PropsWithChildren {
}

export const IntlProviderWrapper: FunctionComponent<IWrapperProps> = (props) => {
    const [locale, setLocale] = useState(defaultLocale);
    const [messages, setMessages] = useState(LocalizedStrings[defaultLocale]);

    const switchToFinnish = () => {
        setLocale("fi-FI");
        setMessages(LocalizedStrings["fi-FI"]);
        document.documentElement.lang="fi";
    }

    const switchToEnglish = () => {
        setLocale("en-GB");
        setMessages(LocalizedStrings["en-GB"]);
        document.documentElement.lang="en";
    }

    const switchToSwedish = () => {
        setLocale("sv-SE");
        setMessages(LocalizedStrings["sv-SE"]);
        document.documentElement.lang="sv";
    }

    // pass everything in state to avoid creating object inside render method (like explained in the documentation)
    const state = {
        locale: locale,
        messages: messages,
        switchToEnglish: switchToEnglish, 
        switchToSwedish: switchToSwedish, 
        switchToFinnish: switchToFinnish 
        };

    return (
        <IntlContext.Provider value={state}>
            <IntlProvider
            locale={locale}
            messages={messages}
            defaultLocale={defaultLocale}
            >
                {props.children}
            </IntlProvider>
        </IntlContext.Provider>
    );
  }